import { render, staticRenderFns } from "./AreaDoAssociadoDashBoard.vue?vue&type=template&id=3b29a002&scoped=true&"
import script from "./AreaDoAssociadoDashBoard.vue?vue&type=script&lang=js&"
export * from "./AreaDoAssociadoDashBoard.vue?vue&type=script&lang=js&"
import style0 from "./AreaDoAssociadoDashBoard.vue?vue&type=style&index=0&id=3b29a002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b29a002",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCardActions,VCardText,VIcon})
